import { CustomCircleTickIcon } from '@nesso/ui/icons/custom-circle-tick';
import { TableCell, TableRow } from '@nesso/ui/primitives/table';

export type SessionTableHeaderRowProps = {
    colSpan: number;
    weekday: string;
    dayAndMonth: string;
    isDayCompleted: boolean;
};

export function PastSessionsTableHeader({
    colSpan,
    weekday,
    dayAndMonth,
    isDayCompleted,
}: SessionTableHeaderRowProps) {
    return (
        <TableRow className="table-row hover:bg-transparent px-6 xs:px-2 h-[3.25rem]">
            <TableCell colSpan={colSpan} className="py-2 px-6 xs:px-2 align-bottom">
                <div className="flex items-center gap-2">
                    <span className="flex flex-row text-base">
                        <span className="font-semibold text-foreground ">{weekday}</span>
                        <span className="text-muted-foreground">{`, ${dayAndMonth}`}</span>
                    </span>
                    {isDayCompleted && (
                        <CustomCircleTickIcon className="size-4 text-toast-success" />
                    )}
                </div>
            </TableCell>
        </TableRow>
    );
}
